module.exports = __webpack_public_path__ + "img/empty.bd1edef0.png";